import AssetCard from "./asset-card";

export default AssetCard;
